import React from 'react';
import { View, Text, TextInput, TouchableOpacity, StyleSheet } from 'react-native';

import UserMinusIcon from './UserMinusIcon';
import UserPlusIcon from './UserPlusIcon';

export default function TeamBuilderMixed({ teams, setTeams, categories }) {
  // Aggiungi squadra
  const addTeam = () => {
    setTeams([...teams, { name: '', members: categories.map(cat => ({ name: '', category: cat, id: Date.now() + Math.random() })) }]);
  };

  // Rimuovi squadra
  const removeTeam = idx => {
    if (teams.length > 2) setTeams(teams.filter((_, i) => i !== idx));
  };

  // Modifica nome squadra
  const updateTeamName = (idx, name) => {
    const updated = [...teams];
    updated[idx].name = name;
    setTeams(updated);
  };

  // Aggiungi membro a categoria
  const addMember = (teamIdx, cat) => {
    const updated = [...teams];
    updated[teamIdx].members.push({ name: '', category: cat, id: Date.now() + Math.random() });
    setTeams(updated);
  };

  // Rimuovi membro
  const removeMember = (teamIdx, memberId) => {
    const updated = [...teams];
    updated[teamIdx].members = updated[teamIdx].members.filter(m => m.id !== memberId);
    setTeams(updated);
  };

  // Modifica nome membro
  const updateMemberName = (teamIdx, memberId, name) => {
    const updated = [...teams];
    updated[teamIdx].members = updated[teamIdx].members.map(m => m.id === memberId ? { ...m, name } : m);
    setTeams(updated);
  };

  return (
    <View>
      {teams.map((team, teamIdx) => (
        <View key={teamIdx} style={styles.card}>
          <View style={{ flexDirection: 'row', alignItems: 'center', marginBottom: 6 }}>
            <TextInput
              style={{...styles.input, flex: 1, marginRight: 8}}
              value={team.name}
              onChangeText={val => updateTeamName(teamIdx, val)}
              placeholder={`Nome squadra ${teamIdx + 1}`}
            />
            <TouchableOpacity
              style={styles.roundBtn}
              onPress={() => removeTeam(teamIdx)}
              disabled={teams.length <= 2}
            >
              <Text style={styles.roundBtnText}>-</Text>
            </TouchableOpacity>
          </View>
          {/* Per ogni categoria */}
          {categories.map(cat => (
            <View key={cat} style={styles.catSection}>
              <View style={styles.catHeaderRow}>
                <Text style={styles.catTitle}>{cat}</Text>
                <TouchableOpacity
                  style={styles.addMemberBtn}
                  onPress={() => addMember(teamIdx, cat)}
                  accessibilityLabel={`Aggiungi atleta ${cat}`}
                >
                  <UserPlusIcon size={22} color="#fff" />
                </TouchableOpacity>
              </View>
              {/* Lista membri */}
              {team.members.filter(m => m.category === cat).map((member, mIdx) => (
                <View key={member.id} style={{ flexDirection: 'row', alignItems: 'center', marginBottom: 4 }}>
                  <TouchableOpacity
                    style={styles.removeMemberBtn}
                    onPress={() => removeMember(teamIdx, member.id)}
                    disabled={team.members.filter(m => m.category === cat).length <= 1}
                  >
                    <UserMinusIcon size={22} color="#d32f2f" />
                  </TouchableOpacity>
                  <TextInput
                    style={{...styles.input, flex: 2, marginRight: 8}}
                    value={member.name}
                    onChangeText={val => updateMemberName(teamIdx, member.id, val)}
                    placeholder={`Nome atleta ${mIdx + 1}`}
                  />
                </View>
              ))}
            </View>
          ))}
        </View>
      ))}
      <TouchableOpacity style={styles.addBtn} onPress={addTeam}>
        <Text style={{color: '#1976d2', fontWeight: 'bold'}}>+ Aggiungi squadra</Text>
      </TouchableOpacity>
    </View>
  );
}

const styles = StyleSheet.create({
  card: {
    backgroundColor: '#fff',
    borderRadius: 18,
    boxShadow: '0 4px 24px #0002',
    padding: 16,
    marginVertical: 12,
    borderWidth: 2,
    borderColor: '#1976d2',
    transition: 'box-shadow 0.2s',
    maxWidth: '100vw',
    overflowX: 'auto',
  },
  input: {
    borderWidth: 2,
    borderColor: '#b3c6e6',
    borderRadius: 8,
    padding: 10,
    marginBottom: 8,
    backgroundColor: '#f4faff',
    fontWeight: 'bold',
    fontSize: 16,
    transition: 'border-color 0.2s',
  },
  addBtn: {
    display: 'none'
  },
  addMemberBtn: {
    backgroundColor: '#1976d2',
    borderRadius: 18,
    width: 36,
    height: 36,
    alignItems: 'center',
    justifyContent: 'center',
    marginLeft: 8,
    marginTop: 2,
    shadowColor: '#1976d2',
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.18,
    shadowRadius: 4,
    elevation: 2,
    borderWidth: 2,
    borderColor: '#1565c0',
  },
  removeMemberBtn: {
    backgroundColor: '#fff',
    borderRadius: 18,
    width: 36,
    height: 36,
    alignItems: 'center',
    justifyContent: 'center',
    marginHorizontal: 6,
    shadowColor: '#d32f2f',
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.18,
    shadowRadius: 4,
    elevation: 2
  },
  catHeaderRow: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginBottom: 4,
    marginTop: 10
  },
  roundBtnText: {
    color: '#fff',
    fontWeight: 'bold',
    fontSize: 20,
    textAlign: 'center',
    lineHeight: 20
  },
  catSection: {
    marginTop: 10,
    marginBottom: 8
  },
  catTitle: {
    fontWeight: 'bold',
    color: '#1976d2',
    fontSize: 15,
    marginBottom: 4
  }
});
